import { Component, ContentChild, Input, OnChanges } from '@angular/core';
import { ActivityIconDirective } from '../../directives/activity-icon.directive';

declare var moment : any;

// One activity as a row of a list group: avatar with an optional icon, the
// author followed by the projected headline (an [scActivityPrefix] goes before
// the author), an optional body and the date.
// With a link the whole row navigates.
@Component({
    selector: 'sc-activity-list-item',
    templateUrl: './activity-list-item.component.html',
    styleUrls: ['./activity-list-item.component.scss'],
    standalone: false
})
export class ActivityListItemComponent implements OnChanges {

  @Input()
  activity : any;

  @Input()
  showProjectName = false;

  // hides the body
  @Input()
  condensed = false;

  // router link commands for the whole row
  @Input()
  link : any = null;

  // leaves the author out of the headline, when the context already names them
  @Input()
  hideUserName = false;

  @ContentChild(ActivityIconDirective)
  icon : ActivityIconDirective;

  humanizeDate = false;

  // system activities carry no author, so the candidate they are about is named
  get user() {
    return this.activity?.Author ?? this.activity?.Candidate;
  }

  get userName() {
    var user = this.user;
    var name = [user?.FirstName, user?.LastName].filter(n => n).join(' ');
    return name || user?.EMail || 'Unbekannt';
  }

  ngOnChanges() {
    if (!this.activity?.Timestamp) return;
    var diff = new moment().diff(new moment(this.activity.Timestamp), 'days');
    this.humanizeDate = diff <= 7;
  }

}
